import React from 'react'
import styles from "../Deseyne/Deseyne.module.css"

const Deseyne = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <div className={styles.content}>
                        <b className={styles.boldText}>Groundbreaking Innovations</b>
                        <p className={styles.description}>Bruno Vision Care is more than a vision correction company. Our soft contact lens technologies are designed to work in harmony with human biology, enhancing vision through the lens itself.</p>
                        <p className={styles.description}>On October 25, 2024 the U.S. Food and Drug Administration cleared two Bruno Vision Care soft contact lens technologies–vifilcon C, a unique hydrogel material using FusionTechnology.</p>

                    </div>
                </div>
                <div className={styles.RightSection}>
                    <div className={styles.eyediv}>
                        <img loading="lazy" src='Images/section3-eye-Img.webp' alt='healthy woman’s eye looking into the camera' />
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Deseyne
